class RecordListCtrl {
  constructor($sce, $uibModal, $filter, $scope, $timeout, $document) {
    'ngInject';
    this.$filter = $filter;
    this.$sce = $sce;
    this.$uibModal = $uibModal;
    this.$timeout = $timeout;
    this.$scope = $scope;
    this.$document = $document;
    this.collapseId = `collapse${$scope.$id}`;
    
    /*** Pagination ***/
    this.pageNumber = 0;
    this.condensed = false;
    this.term = '';
    this.contextMenuVisible = false;
    this.contextMenuStyle = {};
    this.contextMenuRecord = null;
    this.contextMenuIndex = null;
    this.contextMenuItems = [];
    this._onDocumentClick = () => this.hideContextMenu();
  }

  $onInit() {
    this.captionHTML = this.$sce.trustAsHtml(this.caption || "&nbsp;");
    this.collapseGroup && this.configureCollapse();
    this.$scope.$watch('$ctrl.term + $ctrl.records', _ => this.clearActionSelections());
    if (this.rowContextMenu?.length) {
      this.$document.on('click', this._onDocumentClick);
    }
  }

  $onDestroy() {
    this.$document.off('click', this._onDocumentClick);
  }

  getVisibleRowContextMenuItems(record) {
    if (!this.rowContextMenu?.length || !record) return [];
    return this.rowContextMenu.filter(item => !item.visible || item.visible(record));
  }

  showRowContextMenu(record, index, event) {
    const items = this.getVisibleRowContextMenuItems(record);
    if (!items.length) return;
    this.contextMenuRecord = record;
    this.contextMenuIndex = index;
    this.contextMenuItems = items;
    this.contextMenuStyle = {
      top: `${event.clientY}px`,
      left: `${event.clientX}px`,
    };
    this.contextMenuVisible = true;
  }

  hideContextMenu() {
    this.contextMenuVisible = false;
    this.contextMenuRecord = null;
    this.contextMenuIndex = null;
    this.contextMenuItems = [];
  }

  runContextMenuItem(item) {
    const record = this.contextMenuRecord;
    const index = this.contextMenuIndex;
    this.hideContextMenu();
    item.action(record, index);
  }

  itemSelected() {
    this.actionsButtons = this.records.filter(r => r._actionSelected).length;
  }

  clearActionSelections() {
    this.records?.forEach(record => delete record._actionSelected);
    this.actionsButtons = 0;
  }

  configureCollapse() {
    this.$timeout(_ => {
      const $collapseElem = $(`#${this.collapseId}`);
      $collapseElem.on('shown.bs.collapse', () => { this.collapsed = false; this.$scope.$apply() });
      $collapseElem.on('hidden.bs.collapse', () => { this.collapsed = true; this.$scope.$apply() });
      (this.collapsed === false) && $collapseElem.collapse('show');
    }, 100);
  }

  collapseGroupPanels() {
    $(`${this.collapseGroup} .panel-collapse`).collapse('hide');
  }

  cancelModal(){
  }
  
  formatCell(column, index, record) {
    const value = record[column.key];
    const format = column.format;
    const content = (typeof format === "function")? format(value, index, record) : value;
    return this.$sce.trustAsHtml(`${content}`);
  }

  getTooltip(column, index, record) {
    if (!column.tooltip) return this.tooltipFieldId ? record[this.tooltipFieldId] : null;
    if (column.tooltip === true) return this.formatCell(column, index, record);
    if (typeof column.tooltip === 'function') return column.tooltip(record[column.key], index, record);
    return column.tooltip;
  }

  startIdx() {
    return this.pageNumber*this.pageSize;
  }

  getRecordCount(){
    const recCount = ((this.$filter('filter')(this.records, this.term) || {}).length) || 0;
    if (this.pageNumber > Math.floor(recCount/this.pageSize)) {
      this.pageNumber = Math.floor(recCount/this.pageSize);
    }
    if (recCount < this.pageSize) {
      this.pageNumber = 0;
    }
    return recCount;
  }
  
  setSort(key){
    //if already selected, flip the caret and sort direction
    if (this.sortKey == key) {
      this.sortReverse = !this.sortReverse;
    } else {
      this.sortKey = key;
    }
  }

  showNewAction(){
    return !!this.newAction && typeof this.newAction === 'function';
  }

  doAction() {
    this.onRecordsAction({records: this.records.filter(r => r._actionSelected)});
  }
}

export default {
  bindings:{
    caption: '<',
    records: '<',
    columns: '<',
    pageSize: '<',
    search: '<',
    filters: '<',
    headerBtnText: '<',
    hidePagination: '<',
    hideHeader: '<?',
    condensed: '<',
    sortKey: '=',
    sortReverse: '=',
    term: '=?',
    onRecordSelected: '&',
    showNewFile: '<',
    newAction: '<',
    loadingNote: '<?',
    selectedItemIndex: '<?',
    selectedItemId: '<?',
    selectedItemFieldId: '<?',
    collapseGroup: '<?',
    collapsed: '<?',
    panelClass: '<?',
    footerActions: '<?',
    infoText: '<?',
    actionsBtnText: '<',
    onRecordsAction: '&',
    tooltipFieldId: '<?',
    rowContextMenu: '<?',
  },
  templateUrl: 'record-utilities/record-list/record-list.component.html',
  controller: RecordListCtrl
}